<div class="container center">
  <img class="image" src="assets/mobile.svg"/>
  <h3>
    Mobile unavailable
  </h3>
  <p >
    For a good experience, please access via desktop.
  </p>
</div>
